import { clearAllBodyScrollLocks } from 'body-scroll-lock';
const LARGE = 1279;

const dismissDropdown = () => {
  $( '.chr-white-overlay' ).fadeOut();
  $( 'body' ).removeClass( 'filter-dropdown-open' );
  clearAllBodyScrollLocks();
};

const SwitchTabContent = ( target, contentClassname, slug ) => {
  $( target ).find( '.sidebar-name.active' ).removeClass( 'active' );
  $( contentClassname + '.active' ).removeClass( 'active' );
  $( target ).find( '.sidebar-name[data-tab-name="' + slug + '"]' ).addClass( 'active' );
  let newContent = $( contentClassname + '[data-tab-name="' + slug + '"]' );
  newContent.find( '.slick-slider' ).slick( 'setPosition' );
  newContent.addClass( 'active' );

  if ( window.innerWidth < LARGE ) {
    dismissDropdown();
  }
};

/**
 * Update URL slug without refreshing the page
 * @param {String} name - Name
 * @param {String} slug - Slug
 * @returns {Void} nothing
 */
export function addToURL( name, slug ) {
  let url = window.location.href;
  url = url.split( '#' )[0];
  if ( slug ) {
    history.pushState({ 'tab_name': slug }, name, url + '#' + slug );
  } else {
    history.pushState({ 'tab_name': slug }, name, url );
  }
}

/**
 * Handles sidebar changes
 * @param {String} target - String of sidebar target
 * @param {String} contentClassname - String of content Tab
 * @returns {Void} }void
 */
export function handleSidebarChanges( target, contentClassname ) {
  let tabMenus = $( target ).find( '.sidebar-name' );

  tabMenus.on( 'click', function() {
    let currTabName = $( this ).data( 'tab-name' );
    let activeTabName = $( target ).find( '.sidebar-name.active' ).data( 'tab-name' );
    if ( currTabName !== activeTabName ) {
      addToURL( $( this ).text(), currTabName );
      SwitchTabContent( target, contentClassname, currTabName );
    }
  });
}

/**
 * Swap tab conent
 * @param {Object} classList - list of classnames need to swap
 * @param {String} slug - slug
 * @returns {Void} nothing
 */
export function genericSwitchContent( classList, slug ) {

  $( classList.oldSidebar ).removeClass( classList.activeClass );
  $( classList.activeSidebar ).addClass( classList.activeClass );

  if ( slug === classList.allCase ) {
    $( classList.allContent ).each( function() {
      if ( ! $( this ).hasClass( classList.activeClass ) ) {
        $( this ).addClass( classList.activeClass ).slideDown();
      }
    });
  } else {
    $( classList.oldContent ).each( function() {
      if ( $( this ).data( classList.dataLabel ) !== slug ) {
        $( this ).removeClass( classList.activeClass ).slideUp();
      }
    });
    let activeContent = $( classList.activeContent );
    if ( ! activeContent.hasClass( classList.activeClass ) ) {
      activeContent.addClass( classList.activeClass ).slideDown();
    }
  }

  // Reset slick slider styles
  let sliders = $( classList.activeContent ).find( '.slick-slider' );
  if ( sliders.length > 0 ) {
    sliders.each( function() {
      $( this ).slick( 'setPosition' );
    });
  }

  setTimeout( () => {
    if ( window.innerWidth < LARGE ) {
      dismissDropdown();
    }
  }, 50 );
}
